import React, { useEffect} from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

import useCookie from "../hooks/useCookie";
import Notification from "./shared/Notification";

const Layout = () => {

    const [, i18n] = useTranslation();
    const [ulaCookie, setUlaCookie] = useCookie("ULA");

    useEffect(() => {
        const initializeLanguage = () => {
          if (ulaCookie) {
            i18n.changeLanguage(JSON.parse(ulaCookie));
          } else {
            const browserLang = navigator.language.split("-")[0];
            const defaultLang = browserLang === "sk" || browserLang === "cs" ? browserLang : "en";
            i18n.changeLanguage(defaultLang);
            setUlaCookie("ULA", JSON.stringify(defaultLang), { maxAge: 86400 });
          }
        };
    
        initializeLanguage();
      }, []);

    return (
        <main className="App">
            <Notification /> 
            <Outlet/>
        </main>
    )
}

export default Layout;